
import React from 'react';
import { Music } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="py-8 px-4 border-t border-white/10 backdrop-blur-md">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center">
        <div className="flex items-center gap-2 mb-4 md:mb-0">
          <Music className="h-5 w-5 text-neon-purple" />
          <span className="text-gradient-neon text-lg font-bold">Muso360</span>
        </div>
        
        <div className="text-white/60 text-sm">
          © {new Date().getFullYear()} Muso360. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
